import { Component, OnInit, AfterViewInit } from '@angular/core';
import { fciWebsiteService } from '../../service/fci-website.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { environment } from 'src/environments/environment';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { CustomServiceService } from '../../service/custom-service.service';

declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-video-category-archive',
  templateUrl: './video-category-archive.component.html',
  styleUrls: ['./video-category-archive.component.css']
})
export class VideoCategoryArchiveComponent implements OnInit {

  constructor(private fciwebservice: fciWebsiteService, private router: ActivatedRoute, private encDec: EncryptDecryptService, private route: Router, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, public translate: TranslateService) { }

  imageUrl = environment.serviceURL + 'storage/app/uploads/';
  backendUrl = environment.serviceURL;
  content_apiresponse: any;
  photolength: any;
  galleryCat: any = [];
  galleryCatnew: any = [];
  categorylength: any;
  gallery: any;
  GalleryLength: any;

  plugin_menu_dtl: any;
  employee_con: any = "";

  language: any = '';
  CURRENT_ZONE_ID: any = environment.ZONE_ID;
  CURRENT_REGION_ID: any = environment.REGION_ID;
  CURRENT_ZONE_CODE: any = environment.ZONE_CODE;
  CURRENT_REGION_CODE: any = environment.REGION_CODE;
  datetime: any = this.httpservice.currentDateTime();
  ngOnInit(): void {

    this.language = sessionStorage.getItem('locale'); //dynamic content language translation 

    this.getGalleryCatList();

    this.employee_con = this.routerparam.snapshot.queryParamMap.get('emp');
    if (this.employee_con == null) {
      this.plugin_menu_dtl = window.sessionStorage.getItem(btoa(this.CurrentRouteFn()));
      this.getPluginPageDetials(this.plugin_menu_dtl);
    } else {
      this.getEmployeeCornerDtl(this.encDec.decText(this.employee_con));
    }

  }

  photoprogress: boolean = false;
  getGalleryCatList() {
    this.photoprogress = true;
    let params = [{
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": '',
      "orderBy": [{ "columnName": "intId", "type": "DESC" }],
      "condition": [
        { "columnName": "VCHMEDIATYPE", "operator": "=", "value": 2, "joinoperator": "and" },
        { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
        { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" }
      ],
      "viewParameters": ""
    }];
    this.fciwebservice.getGalleryCat(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.galleryCatnew = response.result.sec_1;
            let i = 1;
            this.galleryCatnew.forEach((element: any) => {

              // let catid = element.id;
              // var query = [];
              // query = [
              //   { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
              //   { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" },
              //   { "columnName": "UPLOAD_TYPE", "operator": "=", "value": 2, "joinoperator": "and" },
              //   { "columnName": "VCHVIDEOCAT", "operator": "=", "value": catid, "joinoperator": "and" },
              //   { "columnName": "ARCHIVE_DATE", "operator": "<=", "value": this.datetime.date, "joinoperator": "and" },
              // ];
              // let params = [{
              //   "secSlNo": 1,
              //   "offSet": 0,
              //   "noOfRecords": '',
              //   "orderBy": [{ "columnName": "intId", "type": "ASC" }],
              //   "condition": query,
              //   "viewParameters": ""
              // }];
              let params = {
                "UPLOAD_TYPE": 2,
                "CATEGORYID": element.id,
                "bitDeletedFlag": 0,
                "tinPublishStatus": 1,
                "ARCHIVEDATE": this.datetime.date,
                "ARCHIVE_DATE_type": "<=",
              };
              this.fciwebservice.countvideophoto(params, 'api/count-video-photo').subscribe((response: HttpEvent<any>) => {
                switch (response.type) {
                  case HttpEventType.Sent:
                    //console.log('Sent' + HttpEventType.Sent);
                    break;
                  case HttpEventType.ResponseHeader:
                    //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
                    break;
                  case HttpEventType.UploadProgress:
                    //this.evenTotal = response.total;
                    //this.progress = Math.round(response.loaded / this.evenTotal * 100);
                    break;
                  case HttpEventType.Response:
                    this.content_apiresponse = response.body;
                    let respData = this.content_apiresponse.RESPONSE_DATA;
                    let respToken = this.content_apiresponse.RESPONSE_TOKEN;
                    let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
                    if (respToken == verifyToken) {
                      let res: any = Buffer.from(respData, 'base64');
                      res = JSON.parse(res);
                      // console.log(res);
                      element.photolength = res.result;//res.result.sec_1.length;
                      if (i == this.galleryCatnew.length) {
                        this.photoprogress = false;
                      }
                      i++;

                    }
                }
              });
            });
          }
      }
      let imeInteval: any = setInterval((): any => {
        if (!this.photoprogress) {
          this.galleryCat = [];
          this.galleryCatnew.forEach((element: any) => {
            if (element.photolength > 0) {
              this.galleryCat.push(element);
            }
          });
          clearInterval(imeInteval);
        }
      }, 500);
    });

  }
  showBarComponent: boolean = false;
  emp_apires: any;
  showEmpMen: boolean = false;
  p_apirespons: any;
  P_data: any;
  navMenu: boolean = false;
  navmenuloadCss = "background-color: #167a44; height: 100%;";
  showNavComponent: boolean = false;


  emp_dtl: any = { 'title': '' };
  getEmployeeCornerDtl(id: any) {
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [],
        "condition": [
          { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
          { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
          { "columnName": "intId", "operator": "=", "value": id, "joinoperator": "and" },
        ],
        "viewParameters": ""
      }];
    this.httpservice.EmpeeloyCorner(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.emp_apires = response.body;
          let respData = this.emp_apires.RESPONSE_DATA;
          let respToken = this.emp_apires.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response_: any = Buffer.from(respData, 'base64');
            response_ = JSON.parse(response_);
            if (response_.result.sec_1.length > 0) {
              this.emp_dtl = response_.result.sec_1[0];
              this.showBarComponent = true;
              this.showEmpMen = true;
            }
          }
      }
    });
  }

  CurrentRouteFn: any = (): any => {
    let route_url: any = this.route.url.replace('/', "");
    route_url = route_url.split("?");
    if (route_url.length > 0) {
      return route_url[0];
    }
    return route_url;
  }

  getPluginPageDetials(details: any) {
    let params;
    if (details !== null) {
      let d = JSON.parse(details);
      params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": d.plugin_id,
        'router_link': d.selectPlugin,
        'localdata': true,
      };
    } else {
      params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": false,
        'router_link': this.CurrentRouteFn(),
        'localdata': false,
      };
    }
    this.httpservice.PluginPageDetials(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.p_apirespons = response.body;
          let respData = this.p_apirespons.RESPONSE_DATA;
          let respToken = this.p_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response_: any = Buffer.from(respData, 'base64');
            response_ = JSON.parse(response_);
            // console.log(response_.original);
            if (response_.original.status) {
              this.P_data = response_.original;
              this.navMenu = response_.original.hasMenu;
              this.navmenuloadCss = "height: 100%;";
            } else {
              this.P_data = response_.original;//somthing wrong
            }
            this.showNavComponent = true;
            this.showBarComponent = true;
          }
      }
    });
  }

  getTotalLength(): number {
    return this.photolength;
  }
  viewDetails(id: any, pageName: any) {
    let encSchemeStr = this.encDec.encText(id.toString());
    this.route.navigate(['./' + pageName + '/', encSchemeStr]);
  }
  htmldecode(str: any) {
    return this.encDec.decodeHtml(str);
  }

}

